<template>
  <div class="card-divider-full grey lighten-2"></div>
</template>

<script>
export default {};
</script>

<style>
.card-divider-full {
  /* width: 100%; */
  height: 1px;
  margin: 10px 0px;
}
</style>
